// extracted by mini-css-extract-plugin
export default {"root":"SignInForm_root__yyZX9","inputLink":"SignInForm_inputLink__sVGwO","after":"SignInForm_after__ssCSK"};